import Crud from '../views/Client/Crud'
import Entity from '../views/Client/Add'

let routes = {
    path: '/clients',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/clients/add',
            name: 'NewClient',
            component: Entity,
            meta: {
                pageTitle: 'Cliente',
                breadcrumb: [
                    {
                        text: 'Cliente',
                        active: false,
                        to: '/clients',
                    },
                    {
                        text: 'Adicionar Cliente',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/clients/edit/:id?',
            name: 'EditClient',
            component: Entity,
            meta: {
                pageTitle: 'Cliente',
                breadcrumb: [
                    {
                        text: 'Cliente',
                        active: false,
                        to: '/clients',
                    },
                    {
                        text: 'Editar Cliente',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/clients',
            name: 'list-clients',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Cliente',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
